
(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npNavigateToggle', function () {
        return {
            restrict: 'E',
            controller: ['$scope', '$http', 'treeNavigationService', 'localStorageService', controller],
            controllerAs: 'vm',
            templateUrl: '/app/shared/navigation/navigateToggle.html',
            scope: {

            },
            link: function (scope, element, attr) {

            }
        };
    });

    function controller($scope, $http, treeNavigationService, localStorageService) {
        var vm = this;
		vm.showToggleButton = HandbookConfiguration.AutoHighlightInTree.toUpperCase() == "FALSE";
        vm.toggleNavigate = toggleNavigate;
        vm.showInTreeviewInLeftMenu = globalResources.ShowInTreeviewInLeftMenu;
        vm.initialize = function () {
            vm.navigateSideBar = false;
            buildTooltip();
        };

        function toggleNavigate() {
            vm.navigateSideBar = !vm.navigateSideBar;
            treeNavigationService.navigateToItemLocation(vm.navigateSideBar, true);
        };

        function buildTooltip() {
            var availWidth = screen.availWidth;
            var availHeight = screen.availHeight;

            if (!((availWidth <= 768 && availHeight <= 1024) || (availHeight <= 768 && availWidth <= 1024))) {
                vm.showInTreeviewInLeftMenu = globalResources.ShowInTreeviewInLeftMenu + ' \r(CTRL + ALT + N)';
            }
        }

        $(window).on('resize', function () {
            buildTooltip();
        });
    };

})();